import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        pulsating: 'bg-primary text-primary-foreground shadow hover:bg-primary/90 animate-pulse',
        default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline:
          'border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground',
        secondary:
          'bg-secondary border border-foreground text-secondary-foreground disabled:bg-secondary/60 shadow-sm hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        success: 'border-transparent bg-green-500 text-white shadow hover:bg-green-500/80',
        muted: 'bg-muted text-muted-foreground shadow-sm',
      },
      size: {
        default: 'h-9 px-4 py-2 touch:h-11',
        sm: 'h-8 rounded-md px-3 text-xs touch:h-11',
        xs: 'text-xs h-7 px-2 touch:h-11',
        lg: 'h-10 rounded-md px-8 touch:h-11',
        icon: 'h-9 w-9 touch:h-11 touch:w-11',
        'icon-sm': 'h-6 w-6 min-w-6 touch:h-11 touch:w-11',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
